import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosFlagCss = ":host{display:inline-block}img{display:block;height:100%;width:var(--cosmos-flag-width, 100%)}";

const CosmosFlag$1 = /*@__PURE__*/ proxyCustomElement(class CosmosFlag extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        /**
         * The alternative accessible text for the flag.
         */
        this.alt = '';
        /**
         * Defines whether a browser should load an image immediately (eager) or defer loading of off-screen images until for example, the user scrolls near them (lazy).
         * For more, see: https://developer.mozilla.org/en-US/docs/Web/API/HTMLImageElement/loading
         */
        this.loading = 'eager';
    }
    getFlagUrl() {
        if (this.code == 'TW' || this.code == 'TPE') {
            return `https://rbds-static.redbull.com/@cosmos/foundation/latest/flags/cosmos-flag-Worldwide.svg`;
        }
        return `https://rbds-static.redbull.com/@cosmos/foundation/latest/flags/cosmos-flag-${this.code}.svg`;
    }
    render() {
        return (h(Host, { key: '9a862bf21bffc0b81a6a784938a3424562063ad2' }, h("img", { key: '86f0fa8c248e019a4782c46944b66803dffa24fc', part: "base flag", src: this.getFlagUrl(), loading: this.loading, alt: this.alt })));
    }
    static get style() { return cosmosFlagCss; }
}, [1, "cosmos-flag", {
        "alt": [513],
        "code": [513],
        "loading": [513]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-flag"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-flag":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosFlag$1);
            }
            break;
    } });
}

const CosmosFlag = CosmosFlag$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosFlag, defineCustomElement };
